<template>
  <span class="sort-tooltip">
    {{ getTooltipMsg }}
  </span>
</template>

<script>
export default {
  // Use with `sortTooltipRenderer` component
  // for styling the tooltip and add a correct msg in the tooltip.
  name: 'sort-tooltip-renderer',

  props: {
    isAscSort: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    getTooltipMsg () {
      if (this.isAscSort) {
        return this.$t('SORT_DESC')
      } else {
        return this.$t('SORT_ASC')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-tooltip{
  position: absolute; font-size: 12px; line-height: 1.1; font-family: 'Arimo', sans-serif; font-weight: normal;
  color: #fff; width: 76px; padding: 4px; background: #000; text-align: center; border-radius: 3px;
  display: none; z-index: 10000; inset-inline-end: -85px; top: 13px;
  &:after{
    content: ''; inset-inline-end: 63px; top: 17%; position: absolute;
    border: 6px solid; border-color: transparent #000 transparent transparent;
    .rtl &{transform: translateY(0%) translateX(100%) rotate(-180deg);}
    .ltr &{transform: translateY(0%) translateX(-100%) rotate(0deg);}
  }
}
.icon-sorting:hover + .sort-tooltip{display: block;}
</style>
